import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// project imports
import useConfig from './useConfig';
import { useAppSelector } from 'hooks/useAppStore';
import { selectAccountInfo } from 'features/account/accountSelectors';

// types
import { Translation } from 'models/i18n';

// ==============================|| HOOKS ||============================== //

const useLocale = (): void => {
  const { locale, onChangeLocale } = useConfig();
  const { i18n } = useTranslation();

  const getNavigatorLanguage = (): string => {
    return navigator.languages && navigator.languages.length
      ? navigator.languages[0].substring(0, 2)
      : navigator.language?.substring(0, 2);
  };

  const getLocaleValue = useCallback(
    (kcLocale: string | undefined): string => {
      const navigatorLanguage = getNavigatorLanguage();

      switch (true) {
        case kcLocale &&
          [Translation.SK, Translation.EN].indexOf(kcLocale as Translation) >
            -1:
          i18n.changeLanguage(kcLocale);
          return kcLocale as string;
        case !kcLocale &&
          [Translation.SK, Translation.EN].indexOf(
            navigatorLanguage as Translation
          ) > -1:
          i18n.changeLanguage(navigatorLanguage);
          return navigatorLanguage as string;
        case !!locale && locale !== i18n.language:
          i18n.changeLanguage(locale);
          return locale;
        default:
          return i18n.language;
      }
    },
    [i18n, locale]
  );

  const accountInfo = useAppSelector(selectAccountInfo);
  useEffect(() => {
    if (accountInfo) {
      onChangeLocale(getLocaleValue(accountInfo.locale));
    }
  }, [accountInfo, getLocaleValue, onChangeLocale]);
};

export default useLocale;
